'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var fonts = require('./fonts.js');
var index = require('../theme/index.js');
require('@babel/runtime/helpers/defineProperty');
require('../components/Alert/Alert.js');
require('../components/Alert/AlertDescription.js');
require('../components/Alert/AlertIcon.js');
require('../components/Alert/AlertTitle.js');
require('../components/Alert/alertContext.js');
require('@chakra-ui/utils');
require('../components/CloseButton/CloseButton.js');
require('@babel/runtime/helpers/toConsumableArray');
require('@babel/runtime/helpers/slicedToArray');
var toast_provider = require('../components/Toast/toast.provider.js');
require('@internationalized/date');
var reactAria = require('react-aria');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "theme", "locale", "allowToasts"];
var BaseDesignsystemProvider = function BaseDesignsystemProvider(props) {
  var children = props.children,
    _props$resetCSS = props.resetCSS,
    resetCSS = _props$resetCSS === void 0 ? true : _props$resetCSS,
    _props$fonts = props.fonts,
    fonts$1 = _props$fonts === void 0 ? true : _props$fonts,
    theme = props.theme,
    colorModeManager = props.colorModeManager,
    environment = props.environment,
    portalZIndex = props.portalZIndex,
    cssVarsRoot = props.cssVarsRoot;
  React.useEffect(function () {
    if (fonts$1) {
      fonts["default"]();
    }
  }, []);
  var _children = /*#__PURE__*/React__default["default"].createElement(react.EnvironmentProvider, {
    environment: environment
  }, children);
  return /*#__PURE__*/React__default["default"].createElement(react.ThemeProvider, {
    theme: theme,
    cssVarsRoot: cssVarsRoot
  }, /*#__PURE__*/React__default["default"].createElement(react.ColorModeProvider, {
    colorModeManager: colorModeManager,
    options: theme.config
  }, resetCSS ? /*#__PURE__*/React__default["default"].createElement(react.CSSReset, null) : /*#__PURE__*/React__default["default"].createElement(react.CSSPolyfill, null), /*#__PURE__*/React__default["default"].createElement(react.GlobalStyle, null), portalZIndex ? /*#__PURE__*/React__default["default"].createElement(react.PortalManager, {
    zIndex: portalZIndex
  }, _children) : _children));
};
function DesignsystemProvider(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? index["default"] : _ref$theme,
    locale = _ref.locale,
    _ref$allowToasts = _ref.allowToasts,
    allowToasts = _ref$allowToasts === void 0 ? true : _ref$allowToasts,
    restProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  return /*#__PURE__*/React__default["default"].createElement(BaseDesignsystemProvider, _extends__default["default"]({
    theme: theme
  }, restProps), /*#__PURE__*/React__default["default"].createElement(reactAria.I18nProvider, {
    locale: locale
  }, children, allowToasts && /*#__PURE__*/React__default["default"].createElement(toast_provider.ToastProvider, null)));
}
exports["default"] = DesignsystemProvider;